import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import './TextInput.css';
import { types } from './store/types';

const defaultText =
	'Full participation, however, stands in contrast to only one aspect of the concept of peripherality as we see it: It places the emphasis on what partial participation is not, or not yet. In our usage, peripherality is also a positive term, whose most salient conceptual antonyms are unrelatedness or irrelevance to ongoing activity. The partial participation of newcomers is by no means "disconnected" from the practice of interest. Furthermore, it is also a dynamic concept. In this sense, peripherality, when it is enabled, suggests an opening, a way of gaining access to sources for understanding through growing involvement. The ambiguity inherent in peripheral participation must then be connected to issues of legitimacy, of the social organization of and control over resources, if it is to gain its full analytical potential.';

interface InputProps {
	setWebTextInput: Function;
	showDownloadAddinsButton: Function;
}
const TextInput: React.FC<InputProps> = ({
	setWebTextInput,
	showDownloadAddinsButton,
}: InputProps) => {
	const [text, setText] = useState<string>('');
	const textRef = useRef<HTMLTextAreaElement>(null);
	const onInputChange = (_e: React.MouseEvent<HTMLButtonElement>) => {
		const inputText = text.trim();
		const result = inputText === '' ? defaultText : inputText;
		setWebTextInput(result);
		showDownloadAddinsButton();
		setText(result);
	};
	const onTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		setText(e.target.value);
	};
	return (
		<div>
			<h1 className="test-header">The Test</h1>
			<p className="top">
				Enter a text sample of between 100 to 1000 words, then click &#34;run
				the test&#34; to see your result. (To test a longer length document,
				download the free Writer&#39;s Diet app for MS Word&nbsp;
				<a
					href="https://appsource.microsoft.com/en-us/product/office/WA200002125?src=office"
					target="_blank"
					rel="noopener noreferrer">
					here
				</a>
				.)
			</p>
			<div className="tex-input-container">
				<textarea
					className="text-input"
					aria-label="enter text sample"
					ref={textRef}
					onChange={onTextChange}
					value={text}
				/>
			</div>
			<div className="bottom-text">
				<button className="page-button" onClick={onInputChange}>
					run the test
				</button>
			</div>
		</div>
	);
};
const mapDispatchToProps = (dispatch: Function) => ({
	setWebTextInput: (text: string) => {
		dispatch({ type: types.WEB_TEXT_INPUT, text });
	},
	showDownloadAddinsButton: () => {
		dispatch({ type: types.DOWNLOAD_ADDINS_SHOW, show: true });
	},
});

const mapStateToProps = ({ webTextInput }: any) => ({
	webTextInput,
});
export default connect(mapStateToProps, mapDispatchToProps)(TextInput);
